import styles from "./style.module.css";

export const ComboboxHeading = ({ text }: { text: string }) => (
  <div className={styles.comboboxHeading}>{text}</div>
);
